
<template>
  <div style="margin-top: 10px">
    <div class="validation-section">
      <div class="row">
        <div class="col-md-12">
          <label>Ingrese la Patente</label>
        </div>
      </div>
      <div class="row" style="margin-bottom: 0;">
        <div class="col-md-12" style="padding-right: 10px;">
          <base-input
            v-model="model.Aux1"
            @blur="change"
            :disabled="this.disabledFormulario"
            :maxlength="7"
            onkeyup="javascript:this.value=this.value.toUpperCase();"
          ></base-input>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <label>Zona</label>
        </div>
      </div>
      <div class="row" style="margin-bottom: 0;">
        <div class="col-md-12" style="padding-right: 10px;">
          <KitsCombo
            v-model="Aux3"
            :disabled="this.disabledFormulario"
            v-on:input="change"
            v-bind:items="zonas"
            propertyName="NombreZona"
            propertyID="IDZonaExterno"
            nullText=" -- Seleccione una zona -- "
            :todos="true"
          ></KitsCombo>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <label>Ingrese los minutos</label>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-sm-8 col-xs-6">
          <base-input v-model="model.Aux2" @blur="change" :disabled="this.disabledFormulario"></base-input>
        </div>
      </div>
      <div class="row" style="text-align:right">
        <div class="col-md-6">
          <base-button
            :disabled="this.disabledFormulario"
            type="warning"
            size="lg"
            @click="validateUser"
            style="margin: auto; margin-top: 10px"
          >
            <i class="fa fa-check fa-fw"></i>Validar
          </base-button>
        </div>
      </div>
    </div>
    <div class="recarga-section">
      <div class="row">
        <div class="col-md-12">
          <money-with-indicator
            v-model="model.Importe"
            v-on:blur="change"
            v-on:validatedOK="onSaldoOK"
          />
        </div>
      </div>
    </div>
    <div class="row" style="text-align:right">
      <div class="col-md-6">
        <base-button
          type="warning"
          :disabled="!this.disabledFormulario"
          size="lg"
          @click="anularValidacion"
          style="margin: auto; margin-top: 10px"
        >
          <i class="fa fa-check fa-fw"></i>Anular Validacion
        </base-button>
      </div>
    </div>
  </div>
</template>

<script>
import axiosHelpers from "@/helpers/axiosHelpers";
import KitsCombo from "@/components/KitsCombo";
import MoneyWithIndicator from "@/components/Custom/MoneyWithIndicator";
import ResimpleSlider from "@/components/Custom/ResimpleSlider";
import notificationHelpers from "@/helpers/notificationHelpers";

export default {
  components: {
    KitsCombo,
    MoneyWithIndicator,
    notificationHelpers,
    "resimple-slider": ResimpleSlider
  },
  props: {
    model: {
      Aux1: "",
      Aux2: "",
      Aux3: "",
      Aux4: "",
      Importe: "",
      Validate: false,
      Errors: []
    }
  },
  data() {
    return {
      Aux3: 0,
      zonas: [],
      validatePrice: false,
      price: "",
      disabledFormulario: false,
      disabledValidar: false
    };
  },

  beforeMount() {
    this.cargarDatos();
  },
  mounted() {},

  methods: {
    async cargarDatos() {
      let context = this;
      axiosHelpers.axiosGet("Recarga/GetParkingJunin", {}, context, function(
        data
      ) {
        context.zonas = data.ResponseVM.Estacionamiento;
      });
    },
    change(element) {
      this.model.Aux3 = this.Aux3;
      this.validate();
      this.$emit("input", this.model);
    },
    onSaldoOK(val) {
      this.$emit("saldoOK", val);
    },
    validateUser() {
      let context = this;
      context.validateInterno();
      if (context.model.Errors.length == 0) {
        axiosHelpers.axiosGet(
          "Recarga/ValidateJunin",
          {
            Minutos: parseInt(context.model.Aux2),
            Patente: context.model.Aux1,
            ZonaId: this.Aux3
          },
          context,
          function(data) {
            context.validated = false;

            if (data.ResponseVM.Success) {
              context.model.Importe = data.ResponseVM.Price;
              context.validatePrice = true;
              context.model.Validate = true;
              context.disabledValidar = true;
              context.disabledFormulario = true;
            } else {
              context.model.Importe = 0;
              context.validatePrice = false;
              notificationHelpers.showError(
                "Error",
                data.ResponseVM.UIMessage,
                this
              );
            }
          }
        );
      } else {
        context.model.Errors.forEach(element => {
          notificationHelpers.showError("Error", element, this);
        });
      }
      context.$emit("input", context.model);
    },
    validateInterno() {
      let context = this;
      context.model.Errors = [];

      var patenteVieja = /^[a-zA-Z]{3}[0-9]{3}$/;
      var patenteNueva = /^[a-zA-Z]{2}[0-9]{3}[a-zA-Z]{2}$/;

      if (context.model.Aux1 == null || context.model.Aux1.length == 0) {
        context.model.Validate = false;
        context.model.Errors.push("Debe ingresar Patente");
      } else if (context.model.Aux1.length < 5) {
        context.model.Validate = false;
        context.model.Errors.push(
          "La patente debe tener al menos 5 caracteres"
        );
      } else if (
        !(
          patenteVieja.test(context.model.Aux1) ||
          patenteNueva.test(context.model.Aux1)
        )
      ) {
        context.model.Validate = false;
        context.model.Errors.push(
          "La patente tiene un formato invalido debe ser en formato ABC123 o AB123CD"
        );
      } else if (context.model.Aux2 == null || context.model.Aux2.length == 0) {
        context.model.Validate = false;
        context.model.Errors.push("Debe ingresar los minutos");
      } else if (parseInt(context.model.Aux2) % 60 != 0) {
        context.model.Validate = false;
        context.model.Errors.push("Los minutos deben ser:  60  120  180 o 240");
      } else if (
        context.model.Aux3 == null ||
        isNaN(context.model.Aux3) ||
        context.model.Aux3 == 0
      ) {
        context.model.Validate = false;
        context.model.Errors.push("Debe elegir alguna zona");
      } else {
        this.model.Errors = [];
      }
    },
    validate() {
      let context = this;
      context.validateInterno();
      if (!context.validatePrice) {
        context.model.Validate = false;
        context.model.Errors.push(
          "Debes validar el importe antes de realizar la recarga"
        );
      }
    },
    anularValidacion() {
      let context = this;
      context.model.Importe = 0;
      context.disabledFormulario = false;
      context.validatePrice = false;
      context.model.Validate = false;
      context.SelectedCalleID = null;
      context.model.Aux1 = "";
      context.model.Aux2 = "";
      context.Aux3 = null;
    }
  }
};
</script>